import { render, staticRenderFns } from "./TheProfileFooter.vue?vue&type=template&id=567ad30c&"
import script from "./TheProfileFooter.vue?vue&type=script&lang=js&"
export * from "./TheProfileFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports